/* eslint-disable new-cap */
import {html} from 'lit';
import {FacetBasic} from '../facet-basic/facet-basic';
import noUiSlider from 'nouislider';
import {createRef, ref} from 'lit/directives/ref.js';
import {defineCustomElement, formatNumber, formatPrice} from 'extensions/utils';
import styles from './facet-range-slider.component.scss?as=stylesheet';

export class FacetRangeSlider extends FacetBasic {
	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	slider = createRef();

	constructor () {
		super();
	}

	get sliderFormat () {
		return {
			from: value => {
				return Math.round(value);
			},
			to: value => {
				return this.facet?.range?.type === 'currency'
					? formatPrice(value)
					: formatNumber(value);
			}
		};
	}

	get sliderOptions () {
		return {
			ariaFormat: this.sliderFormat,
			connect: true,
			format: this.sliderFormat,
			handleAttributes: [
				{
					'aria-label': `Minimum ${this.facet.title}`
				},
				{
					'aria-label': `Max ${this.facet.title}`
				}
			],
			pips: {
				density: 99999,
				filter () {
					return 1;
				},
				format: this.sliderFormat,
				mode: 'positions',
				stepped: true,
				values: [
					0,
					100
				]
			},
			range: {
				max: this.facet.range.max,
				min: this.facet.range.min
			},
			start: [
				this.facet.range.start,
				this.facet.range.end
			],
			step: this.facet?.custom?.step || 1
		};
	}

	firstUpdated () {
		noUiSlider.create(
			this.slider.value,
			this.sliderOptions
		);

		// Bind change event listener
		this.slider.value.noUiSlider.on('change', this.handleChange.bind(this));
		this.slider.value.noUiSlider.on('slide', this.handleSlide.bind(this));
	}

	updated () {
		this.slider.value.noUiSlider.updateOptions(this.sliderOptions);
	}

	renderFacetValues () {
		return html`
			<div ${ref(this.slider)}></div>
		`;
	}
};

defineCustomElement('rb-facet-range-slider', FacetRangeSlider);
